import { render, staticRenderFns } from "./SocialVisits.vue?vue&type=template&id=fd7293b0&"
import script from "./SocialVisits.vue?vue&type=script&lang=js&"
export * from "./SocialVisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports